export default __webpack_public_path__ + "static/media/gallery_03.8d83ab63.jpg";